import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FeedbackIcon from "@mui/icons-material/Feedback";
import AppsIcon from "@mui/icons-material/Apps";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import logo from "../../img/logo-v.png";
import AdvisorWidget from "./AdvisorWidget";
import "./MaatwerkResultaten.css";

const Alert = ({ fill = "#E54344" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM7 2.69231C6.5524 2.69231 6.19231 3.0524 6.19231 3.5V7.26923C6.19231 7.71683 6.5524 8.07692 7 8.07692C7.4476 8.07692 7.80769 7.71683 7.80769 7.26923V3.5C7.80769 3.0524 7.4476 2.69231 7 2.69231ZM8.07692 10.2308C8.07692 9.94515 7.96346 9.67123 7.7615 9.46927C7.55954 9.26731 7.28562 9.15385 7 9.15385C6.71438 9.15385 6.44046 9.26731 6.2385 9.46927C6.03654 9.67123 5.92308 9.94515 5.92308 10.2308C5.92308 10.5164 6.03654 10.7903 6.2385 10.9923C6.44046 11.1942 6.71438 11.3077 7 11.3077C7.28562 11.3077 7.55954 11.1942 7.7615 10.9923C7.96346 10.7903 8.07692 10.5164 8.07692 10.2308Z"
        fill={fill}
      />
    </svg>
  );
};

const Warning = ({ fill = "#FF8C00" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM5.0625 7.875H5.625V6.375H5.0625C4.75078 6.375 4.5 6.12422 4.5 5.8125C4.5 5.50078 4.75078 5.25 5.0625 5.25H6.1875C6.49922 5.25 6.75 5.50078 6.75 5.8125V7.875H6.9375C7.24922 7.875 7.5 8.12578 7.5 8.4375C7.5 8.74922 7.24922 9 6.9375 9H5.0625C4.75078 9 4.5 8.74922 4.5 8.4375C4.5 8.12578 4.75078 7.875 5.0625 7.875ZM6 3C6.19891 3 6.38968 3.07902 6.53033 3.21967C6.67098 3.36032 6.75 3.55109 6.75 3.75C6.75 3.94891 6.67098 4.13968 6.53033 4.28033C6.38968 4.42098 6.19891 4.5 6 4.5C5.80109 4.5 5.61032 4.42098 5.46967 4.28033C5.32902 4.13968 5.25 3.94891 5.25 3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3Z"
        fill={fill}
      />
    </svg>
  );
};

const NoRisk = ({ fill = "#27CA40" }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM10.8029 5.41827C11.1192 5.10192 11.1192 4.59039 10.8029 4.2774C10.4865 3.96442 9.975 3.96106 9.66202 4.2774L5.92644 8.01298L4.34471 6.43125C4.02837 6.1149 3.51683 6.1149 3.20385 6.43125C2.89087 6.7476 2.8875 7.25913 3.20385 7.57212L5.35769 9.72596C5.67404 10.0423 6.18558 10.0423 6.49856 9.72596L10.8029 5.41827Z"
        fill={fill}
      />
    </svg>
  );
};

const All = () => {
  return <AppsIcon sx={{ fontSize: "16px", color: "#439BD9" }} />;
};

const TABS = [
  { riskLevel: "all", label: "Alles", Icon: All, className: "all" },
  { riskLevel: 2, label: "Pas op", Icon: Alert, className: "alert" },
  { riskLevel: 1, label: "Let op", Icon: Warning, className: "warning" },
  { riskLevel: 0, label: "Informatief", Icon: NoRisk, className: "no-risk" },
];

const MaatwerkSummary = ({
  checks,
  request,
  setShowDeleteModal,
  setShowModalError,
  setSelectedCheck,
}) => {
  const { t, i18n } = useTranslation();

  const checksForLevel = (riskLevel) =>
    checks.filter(
      (check) =>
        check.textInstanceResults.length !== 0 &&
        (riskLevel === "all" ||
          check.textInstanceResults.some(
            (result) => result.variableOptionInstance.riskLevel === riskLevel
          ))
    );

  const [activeTab, setActiveTab] = useState(() => {
    const firstFilledTab = TABS.find(
      (tab) => checksForLevel(tab.riskLevel).length !== 0
    );
    return firstFilledTab ? firstFilledTab.riskLevel : "all";
  });
  const [expandedLevels, setExpandedLevels] = useState(() => {
    const firstFilledLevel = [2, 1, 0].find(
      (level) => checksForLevel(level).length !== 0
    );
    return firstFilledLevel !== undefined ? [firstFilledLevel] : [];
  });
  const toggleLevel = (riskLevel) =>
    setExpandedLevels((prev) =>
      prev.includes(riskLevel)
        ? prev.filter((level) => level !== riskLevel)
        : [...prev, riskLevel]
    );

  const activeTabConfig = TABS.find((tab) => tab.riskLevel === activeTab);
  const activeChecks = checksForLevel(activeTab);

  const hasRiskChecks =
    checksForLevel(2).length !== 0 || checksForLevel(1).length !== 0;

  const isRental = request?.module?.name?.toLowerCase().includes("huren");

  const showAdvisorWidget = !isRental && hasRiskChecks;

  const renderCheckRow = (check, tabConfig, index) => {
    const CheckIcon = tabConfig.Icon;
    return (
      <div className="summary-result-single" key={index}>
        <div className="summary-result-l">
          <Typography
            sx={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              fontSize: "16px",
              fontWeight: 500,
            }}
            component="span"
          >
            <CheckIcon />
            <span>{t(`check.${check.name}`)}</span>
          </Typography>
          {check.textInstanceResults.length !== 0 && (
            <span className="summary-check-result">
              {i18n.language === "nl"
                ? check.variableResult?.summaryNL || t("nietGevonden")
                : check.variableResult?.summaryEN || t("nietGevonden")}
            </span>
          )}
        </div>
        <div className="summary-result-r">
          <span
            className={`check-redirect ${tabConfig.className}`}
            onClick={() => setSelectedCheck(check)}
          >
            {t("klikVoorDetails")}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="summary-container">

      <div className="summary-container-l">
        <div className="summary-tabs">
          {TABS.map((tab) => {
            const TabIcon = tab.Icon;
            const isActive = activeTab === tab.riskLevel;
            const isEmpty = checksForLevel(tab.riskLevel).length === 0;
            return (
              <button
                key={tab.riskLevel}
                type="button"
                disabled={isEmpty}
                className={`summary-tab ${tab.className}${
                  isActive ? " active" : ""
                }`}
                onClick={() => setActiveTab(tab.riskLevel)}
              >
                <TabIcon />
                <span className="summary-tab-label">{t(tab.label)}</span>
                <span className="summary-tab-count">
                  {checksForLevel(tab.riskLevel).length}
                </span>
              </button>
            );
          })}
        </div>

        {activeTab === "all" ? (
          <React.Fragment>
            {activeChecks.length === 0 && (
              <div className="summary-container-single summary-tabs-card">
                <span className="summary-check-result summary-tab-empty">
                  ({t("Geen gevonden")})
                </span>
              </div>
            )}

            {TABS.filter((tab) => tab.riskLevel !== "all").map((tab) => {
              const levelChecks = checksForLevel(tab.riskLevel);
              if (levelChecks.length === 0) return null;
              const TabIcon = tab.Icon;
              const isExpanded = expandedLevels.includes(tab.riskLevel);
              return (
                <div
                  key={tab.riskLevel}
                  className={`summary-container-single summary-accordion ${tab.className}`}
                >
                  <button
                    type="button"
                    className="summary-accordion-header"
                    onClick={() => toggleLevel(tab.riskLevel)}
                  >
                    <TabIcon />
                    <span className="summary-accordion-label">
                      {t(tab.label)}
                    </span>
                    <span className="summary-tab-count">
                      {levelChecks.length}
                    </span>
                    <KeyboardArrowDownIcon
                      className={`summary-accordion-chevron ${
                        isExpanded ? "expanded" : ""
                      }`}
                      sx={{ fontSize: "20px" }}
                    />
                  </button>
                  {isExpanded && (
                    <div className="summary-box-container summary-accordion-body">
                      {levelChecks.map((check, index) =>
                        renderCheckRow(check, tab, index)
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            {showAdvisorWidget && <AdvisorWidget standalone />}
          </React.Fragment>
        ) : (
          <div className="summary-container-single summary-tabs-card">
            {activeChecks.length === 0 && (
              <span className="summary-check-result summary-tab-empty">
                ({t("Geen gevonden")})
              </span>
            )}

            <div className="summary-box-container">
              {activeChecks.map((check, index) =>
                renderCheckRow(check, activeTabConfig, index)
              )}
            </div>

            {(activeTab === 2 || activeTab === 1) &&
              showAdvisorWidget && <AdvisorWidget />}
          </div>
        )}
      </div>

      <div className="summary-container-r">
        <div className="summary-guidance">
          <Typography
            sx={{
              color: "#439BD9",
              fontWeight: "500",
              fontSize: "18px",
            }}
          >
            {t("Samenvatting")}
          </Typography>
          <Typography
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              color: "#454545",
              lineHeight: "1.6",
            }}
          >
            {t("samenvattingText")}
          </Typography>

          <Typography
            sx={{ fontWeight: "500", fontSize: "14px", color: "#454545" }}
          >
            {t("uitlegRisiconiveaus")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              padding: "18px",
              background: "#F7FCFF",
              borderRadius: "8px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <NoRisk />
                <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
                    {t("Informatief")}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#5C5C5C",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {t("laagRisicoText")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Warning />
                <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
                    {t("Let op")}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#5C5C5C",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {t("gemiddeldRisicoText")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Alert />
                <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "500", fontSize: "14px" }}>
                    {t("Pas op")}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#5C5C5C",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {t("hoogRisicoText")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </div>

        {request?.adminComment && (
          <div className="summary-guidance">
            <div className="admin-comment-header">
              <h4>{t("Opmerkingen algemeen")} (1)</h4>
              <FeedbackIcon sx={{ color: "#439BD9", fontSize: "20px" }} />
            </div>
            <div className="admin-comment-from">
              <div className="vwc-avatar">
                <img src={logo} alt="VWC Logo" />
              </div>
              <span>Team Voorwaarden Checker</span>
            </div>
            <div className="admin-comment-text">
              <span style={{ whiteSpace: "pre-wrap" }}>
                {request?.adminComment || ""}
              </span>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default MaatwerkSummary;
